export default from './Selector'


// WEBPACK FOOTER //
// ./src/components/Modules/Selector/index.js